export const formatCurrency = (value: number, fractionDigitsOptional = false) => {
    return value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        ...(fractionDigitsOptional && {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }),
    });
};
